// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 0;
  color: var(--ca-text-primary, #172033);
}

.breadcrumb {
  margin: 1.5rem 0 0 1.5rem;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 0 0 1.25rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.875rem;
}

.breadcrumb-link {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font: inherit;
  cursor: pointer;
}

.breadcrumb-link:hover {
  color: var(--ca-primary-dark, #0d2863);
  text-decoration: underline;
}

.breadcrumb-link:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 3px;
  border-radius: 6px;
}

.breadcrumb-link i,
.breadcrumb-current i {
  font-size: 1.25rem;
}

.breadcrumb-separator {
  color: var(--ca-text-muted, #8c96a8);
}

.breadcrumb-current {
  color: var(--ca-text-secondary, #4b5870);
  font-weight: 500;
}

.verification-page {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 1.5rem;
  margin: 0 auto;
}

.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.25rem;
  margin-bottom: 1.25rem;
}

.page-heading h1 {
  margin: 0 0 0.35rem;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.35rem, 2vw, 1.7rem);
  font-weight: 650;
  line-height: 1.3;
}

.page-heading p {
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
  line-height: 1.55;
}

.page-header-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.result-summary {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.55rem 0.85rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-surface, #fff);
}

.summary-icon {
  display: grid;
  width: 2.35rem;
  height: 2.35rem;
  place-items: center;
  border-radius: 8px;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1.1rem;
}

.result-summary strong,
.result-summary span:last-child {
  display: block;
}

.result-summary strong {
  color: var(--ca-text-primary, #172033);
  font-size: 1rem;
  line-height: 1.3;
}

.result-summary div span {
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.75rem;
  white-space: nowrap;
}

.btn-primary,
.btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 2.6rem;
  padding: 0.65rem 1rem;
  border-radius: var(--ca-radius-md, 8px);
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.25;
  white-space: nowrap;
}

.btn-primary {
  border: 1px solid var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
  color: #fff;
}

.btn-primary:hover {
  border-color: var(--ca-primary-dark, #0d2863);
  background: var(--ca-primary-dark, #0d2863);
  color: #fff;
}

.btn-secondary {
  border: 1px solid var(--ca-border, #dfe4ec);
  background: var(--ca-surface, #fff);
  color: var(--ca-primary, #0e2e80);
}

.btn-secondary:hover {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-hover, #f8faff);
  color: var(--ca-primary-dark, #0d2863);
}

.btn-primary:focus-visible,
.btn-secondary:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 2px;
}

.asset-list-card {
  min-width: 0;
  padding: 1.25rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.search-toolbar {
  display: grid;
  grid-template-columns: minmax(18rem, 1.6fr) minmax(13rem, 0.8fr) auto;
  gap: 0.875rem;
  margin-bottom: 1.25rem;
}

.search-field {
  display: flex;
  min-width: 0;
  align-items: stretch;
}

.search-control {
  width: 100%;
  min-width: 0;
  min-height: 2.65rem;
  border: 1px solid var(--ca-input-border, #dfe4ec);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-input-bg, #fff);
  color: var(--ca-text-primary, #172033);
  font-size: 0.9rem;
}

.search-control:focus {
  border-color: var(--ca-input-focus, #2850ad);
  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.15);
  outline: 0;
}

.search-field .search-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.search-submit {
  display: inline-grid;
  width: 2.8rem;
  flex: 0 0 2.8rem;
  place-items: center;
  border: 1px solid var(--ca-primary, #0e2e80);
  border-radius: 0 var(--ca-radius-md, 8px) var(--ca-radius-md, 8px) 0;
  background: var(--ca-primary, #0e2e80);
  color: #fff;
  font-size: 1rem;
  cursor: pointer;
}

.search-submit:hover {
  background: var(--ca-primary-dark, #0d2863);
}

.table-region {
  min-width: 0;
  overflow-x: auto;
}

.state-panel {
  display: flex;
  min-height: 42vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  text-align: center;
}

.state-panel > i {
  margin-bottom: 0.75rem;
  color: var(--ca-danger, #dc3545);
  font-size: 2rem;
}

.state-panel h2 {
  margin: 0 0 0.5rem;
  font-size: 1.35rem;
}

.state-panel p {
  margin: 0 0 1rem;
  color: var(--ca-text-secondary, #4b5870);
}

.loading-spinner {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  border: 3px solid var(--ca-border, #dfe4ec);
  border-top-color: var(--ca-primary, #0e2e80);
  border-radius: 50%;
  animation: verification-spin 0.8s linear infinite;
}

.loading-spinner-sm {
  width: 1.1rem;
  height: 1.1rem;
  border-width: 2px;
}

.loading-state p {
  margin: 0.8rem 0 0;
}

.inline-loading {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  min-height: 4rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
}

.inline-error {
  margin: 0.75rem 0;
  padding: 0.875rem 1rem;
  border: 1px solid var(--ca-danger, #dc3545);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-text-primary, #172033);
}

.inline-retry {
  margin-left: 0.5rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}

.no-results {
  display: flex;
  min-height: 11rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  padding: 1.5rem;
  color: var(--ca-text-tertiary, #6f7b91);
  text-align: center;
}

.no-results > i {
  color: var(--ca-primary-light, #2850ad);
  font-size: 1.75rem;
}

.no-results h2 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 1.1rem;
}

.no-results p {
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
}

.list-footer {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1.25rem;
  padding-top: 1rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
}

.pagination-summary {
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.85rem;
}

@keyframes verification-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 991.98px) {
  .search-toolbar {
    grid-template-columns: minmax(0, 1fr);
  }
  .page-header-actions {
    justify-content: flex-start;
  }
}
@media (max-width: 767.98px) {
  .verification-page {
    padding: 1rem;
  }
  .breadcrumb {
    margin-left: 1rem;
  }
  .page-header {
    flex-direction: column;
    align-items: stretch;
  }
  .page-header-actions {
    align-items: stretch;
    flex-direction: column;
  }
  .result-summary {
    align-self: flex-start;
  }
  .asset-list-card {
    padding: 0.875rem;
  }
  .list-footer {
    flex-direction: column;
    align-items: stretch;
  }
  .pagination-summary {
    order: 1;
  }
  .list-footer app-pagination {
    max-width: 100%;
    align-self: flex-end;
  }
}
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/asset-management/assets-view/system-assets-verification-view/system-assets-verification-view.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,sCAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,iCAAA;EACA,aAAA;EACA,eAAA;AACF;;AAEA;EACE,sCAAA;EACA,0BAAA;AACF;;AAEA;EACE,0CAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;;EAEE,kBAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,wCAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,YAAA;EACA,sBAAA;AACF;;AAEA;EACE,mBAAA;EACA,sCAAA;EACA,sCAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,SAAA;EACA,wCAAA;EACA,iBAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,iDAAA;EACA,uCAAA;EACA,mCAAA;AACF;;AAEA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,6CAAA;EACA,iCAAA;EACA,iBAAA;AACF;;AAEA;;EAEE,cAAA;AACF;;AAEA;EACE,sCAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,wCAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;;EAEE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,uCAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AACF;;AAEA;EACE,4CAAA;EACA,sCAAA;EACA,WAAA;AACF;;AAEA;EACE,6CAAA;EACA,2CAAA;EACA,WAAA;AACF;;AAEA;EACE,2CAAA;EACA,mCAAA;EACA,iCAAA;AACF;;AAEA;EACE,wCAAA;EACA,4CAAA;EACA,sCAAA;AACF;;AAEA;;EAEE,0CAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,gEAAA;AACF;;AAEA;EACE,aAAA;EACA,qEAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,oBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iDAAA;EACA,uCAAA;EACA,oCAAA;EACA,sCAAA;EACA,iBAAA;AACF;;AAEA;EACE,4CAAA;EACA,gDAAA;EACA,UAAA;AACF;;AAEA;EACE,0BAAA;EACA,6BAAA;AACF;;AAEA;EACE,oBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,4CAAA;EACA,oEAAA;EACA,sCAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AACF;;AAEA;EACE,2CAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,sBAAA;EACA,gCAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,wCAAA;AACF;;AAEA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iDAAA;AACF;;AAEA;EACE,aAAA;EACA,cAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,wCAAA;EACA,iBAAA;AACF;;AAEA;EACE,iBAAA;EACA,sBAAA;EACA,2CAAA;EACA,uCAAA;EACA,wCAAA;EACA,sCAAA;AACF;;AAEA;EACE,mBAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,iCAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,uCAAA;EACA,kBAAA;AACF;;AAEA;EACE,uCAAA;EACA,kBAAA;AACF;;AAEA;EACE,SAAA;EACA,sCAAA;EACA,iBAAA;AACF;;AAEA;EACE,SAAA;EACA,wCAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,qDAAA;AACF;;AAEA;EACE,wCAAA;EACA,kBAAA;AACF;;AAEA;EACE;IAAK,yBAAA;EAEL;AACF;AAAA;EACE;IACE,qCAAA;EAEF;EACA;IACE,2BAAA;EACF;AACF;AAEA;EACE;IACE,aAAA;EAAF;EAGA;IACE,iBAAA;EADF;EAIA;IACE,sBAAA;IACA,oBAAA;EAFF;EAKA;IACE,oBAAA;IACA,sBAAA;EAHF;EAMA;IACE,sBAAA;EAJF;EAOA;IACE,iBAAA;EALF;EAQA;IACE,sBAAA;IACA,oBAAA;EANF;EASA;IACE,QAAA;EAPF;EAUA;IACE,eAAA;IACA,oBAAA;EARF;AACF;AAWA;EACE;;;IAGE,qCAAA;IACA,uCAAA;IACA,gCAAA;IACA,sCAAA;EATF;AACF","sourcesContent":[":host {\n  display: block;\n  min-width: 0;\n  color: var(--ca-text-primary, #172033);\n}\n\n.breadcrumb {\n  margin: 1.5rem 0 0 1.5rem;\n}\n\n.breadcrumb-nav {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin: 0 0 1.25rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.875rem;\n}\n\n.breadcrumb-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--ca-primary, #0e2e80);\n  font: inherit;\n  cursor: pointer;\n}\n\n.breadcrumb-link:hover {\n  color: var(--ca-primary-dark, #0d2863);\n  text-decoration: underline;\n}\n\n.breadcrumb-link:focus-visible {\n  outline: 3px solid rgba(40, 80, 173, 0.25);\n  outline-offset: 3px;\n  border-radius: 6px;\n}\n\n.breadcrumb-link i,\n.breadcrumb-current i {\n  font-size: 1.25rem;\n}\n\n.breadcrumb-separator {\n  color: var(--ca-text-muted, #8c96a8);\n}\n\n.breadcrumb-current {\n  color: var(--ca-text-secondary, #4b5870);\n  font-weight: 500;\n}\n\n.verification-page {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  padding: 1.5rem;\n  margin: 0 auto;\n}\n\n.page-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1.25rem;\n  margin-bottom: 1.25rem;\n}\n\n.page-heading h1 {\n  margin: 0 0 0.35rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: clamp(1.35rem, 2vw, 1.7rem);\n  font-weight: 650;\n  line-height: 1.3;\n}\n\n.page-heading p {\n  margin: 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.9rem;\n  line-height: 1.55;\n}\n\n.page-header-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.result-summary {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.55rem 0.85rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-surface, #fff);\n}\n\n.summary-icon {\n  display: grid;\n  width: 2.35rem;\n  height: 2.35rem;\n  place-items: center;\n  border-radius: 8px;\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.1rem;\n}\n\n.result-summary strong,\n.result-summary span:last-child {\n  display: block;\n}\n\n.result-summary strong {\n  color: var(--ca-text-primary, #172033);\n  font-size: 1rem;\n  line-height: 1.3;\n}\n\n.result-summary div span {\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.75rem;\n  white-space: nowrap;\n}\n\n.btn-primary,\n.btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  min-height: 2.6rem;\n  padding: 0.65rem 1rem;\n  border-radius: var(--ca-radius-md, 8px);\n  font-size: 0.9rem;\n  font-weight: 600;\n  line-height: 1.25;\n  white-space: nowrap;\n}\n\n.btn-primary {\n  border: 1px solid var(--ca-primary, #0e2e80);\n  background: var(--ca-primary, #0e2e80);\n  color: #fff;\n}\n\n.btn-primary:hover {\n  border-color: var(--ca-primary-dark, #0d2863);\n  background: var(--ca-primary-dark, #0d2863);\n  color: #fff;\n}\n\n.btn-secondary {\n  border: 1px solid var(--ca-border, #dfe4ec);\n  background: var(--ca-surface, #fff);\n  color: var(--ca-primary, #0e2e80);\n}\n\n.btn-secondary:hover {\n  border-color: var(--ca-primary, #0e2e80);\n  background: var(--ca-surface-hover, #f8faff);\n  color: var(--ca-primary-dark, #0d2863);\n}\n\n.btn-primary:focus-visible,\n.btn-secondary:focus-visible {\n  outline: 3px solid rgba(40, 80, 173, 0.25);\n  outline-offset: 2px;\n}\n\n.asset-list-card {\n  min-width: 0;\n  padding: 1.25rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\n}\n\n.search-toolbar {\n  display: grid;\n  grid-template-columns: minmax(18rem, 1.6fr) minmax(13rem, 0.8fr) auto;\n  gap: 0.875rem;\n  margin-bottom: 1.25rem;\n}\n\n.search-field {\n  display: flex;\n  min-width: 0;\n  align-items: stretch;\n}\n\n.search-control {\n  width: 100%;\n  min-width: 0;\n  min-height: 2.65rem;\n  border: 1px solid var(--ca-input-border, #dfe4ec);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-input-bg, #fff);\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.9rem;\n}\n\n.search-control:focus {\n  border-color: var(--ca-input-focus, #2850ad);\n  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.15);\n  outline: 0;\n}\n\n.search-field .search-control {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.search-submit {\n  display: inline-grid;\n  width: 2.8rem;\n  flex: 0 0 2.8rem;\n  place-items: center;\n  border: 1px solid var(--ca-primary, #0e2e80);\n  border-radius: 0 var(--ca-radius-md, 8px) var(--ca-radius-md, 8px) 0;\n  background: var(--ca-primary, #0e2e80);\n  color: #fff;\n  font-size: 1rem;\n  cursor: pointer;\n}\n\n.search-submit:hover {\n  background: var(--ca-primary-dark, #0d2863);\n}\n\n.table-region {\n  min-width: 0;\n  overflow-x: auto;\n}\n\n.state-panel {\n  display: flex;\n  min-height: 42vh;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem 1rem;\n  text-align: center;\n}\n\n.state-panel > i {\n  margin-bottom: 0.75rem;\n  color: var(--ca-danger, #dc3545);\n  font-size: 2rem;\n}\n\n.state-panel h2 {\n  margin: 0 0 0.5rem;\n  font-size: 1.35rem;\n}\n\n.state-panel p {\n  margin: 0 0 1rem;\n  color: var(--ca-text-secondary, #4b5870);\n}\n\n.loading-spinner {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  border: 3px solid var(--ca-border, #dfe4ec);\n  border-top-color: var(--ca-primary, #0e2e80);\n  border-radius: 50%;\n  animation: verification-spin 0.8s linear infinite;\n}\n\n.loading-spinner-sm {\n  width: 1.1rem;\n  height: 1.1rem;\n  border-width: 2px;\n}\n\n.loading-state p {\n  margin: 0.8rem 0 0;\n}\n\n.inline-loading {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  min-height: 4rem;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.9rem;\n}\n\n.inline-error {\n  margin: 0.75rem 0;\n  padding: 0.875rem 1rem;\n  border: 1px solid var(--ca-danger, #dc3545);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-danger-bg, #fdecef);\n  color: var(--ca-text-primary, #172033);\n}\n\n.inline-retry {\n  margin-left: 0.5rem;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--ca-primary, #0e2e80);\n  font-weight: 600;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.no-results {\n  display: flex;\n  min-height: 11rem;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.65rem;\n  padding: 1.5rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  text-align: center;\n}\n\n.no-results > i {\n  color: var(--ca-primary-light, #2850ad);\n  font-size: 1.75rem;\n}\n\n.no-results h2 {\n  margin: 0;\n  color: var(--ca-text-primary, #172033);\n  font-size: 1.1rem;\n}\n\n.no-results p {\n  margin: 0;\n  color: var(--ca-text-secondary, #4b5870);\n}\n\n.list-footer {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-top: 1.25rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--ca-border-light, #e9edf3);\n}\n\n.pagination-summary {\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.85rem;\n}\n\n@keyframes verification-spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 991.98px) {\n  .search-toolbar {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .page-header-actions {\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .verification-page {\n    padding: 1rem;\n  }\n\n  .breadcrumb {\n    margin-left: 1rem;\n  }\n\n  .page-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .page-header-actions {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .result-summary {\n    align-self: flex-start;\n  }\n\n  .asset-list-card {\n    padding: 0.875rem;\n  }\n\n  .list-footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .pagination-summary {\n    order: 1;\n  }\n\n  .list-footer app-pagination {\n    max-width: 100%;\n    align-self: flex-end;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    scroll-behavior: auto !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
